let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dmT44")).then(() => parcelRequire('a8ipI'));